import React, { useEffect, useState } from 'react';
import Header from "../components/developer_header.jsx";
import Footer from "../components/developer_footer.jsx";
import { Add, Minus } from "iconsax-react";

const PolyFinTechLayout = () => {
  const [isMobile, setIsMobile] = React.useState(false);
  const [expandedFAQ, setExpandedFAQ] = useState({});

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleButtonHover = (e, isHover) => {
    if (isHover) {
      e.target.classList.add('bg-blue-800', 'text-white', 'shadow-lg');
      e.target.classList.remove('bg-blue-600', 'bg-white', 'text-blue-600');
      e.target.style.transform = 'translateY(-2px)';
    } else {
      e.target.classList.remove('bg-blue-800', 'text-white', 'shadow-lg');
      if (e.target.classList.contains('route-button')) {
        e.target.classList.add('bg-blue-600', 'text-white');
      } else {
        e.target.classList.add('bg-white', 'text-gray-800');
      }
      e.target.style.transform = 'translateY(0)';
    }
  };

  const toggleFAQ = (index) => {
    setExpandedFAQ(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const faqData = [
    {
      question: "What's the difference between Skills Development and Competition?",
      answer: (
        <div>
          <div className="mb-3">
            <span className="font-semibold text-blue-600">Skills Development:</span> 
            <span className="ml-2">Structured coursework with certification in Sandbox, Staging, or Production environments. Perfect for learning at your own pace.</span>
          </div>
          <div>
            <span className="font-semibold text-blue-600">Competition:</span> 
            <span className="ml-2">Build prototypes using NETS QR, eNETS, or NETS Click payment gateways to compete for prizes and recognition.</span>
          </div>
        </div>
      )
    },
    {
      question: "How do I book a workshop session?",
      answer: 'Click the "Book Appointment" button in the Workshop section above. You\'ll be directed to a form where you can indicate your preferred workshop certification date and time for both onsite and online sessions.'
    },
    {
      question: "What payment gateways will I learn about?",
      answer: (
        <div>
          <p className="mb-3">You'll work with three main NETS payment solutions:</p>
          <ul className="space-y-2 ml-4">
            <li className="flex items-start">
              <span className="w-2 h-2 bg-blue-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
              <span><strong className="text-blue-600">NETS QR</strong> for QR code payments</span>
            </li>
            <li className="flex items-start">
              <span className="w-2 h-2 bg-blue-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
              <span><strong className="text-blue-600">eNETS</strong> for online transactions</span>
            </li>
            <li className="flex items-start">
              <span className="w-2 h-2 bg-blue-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
              <span><strong className="text-blue-600">NETS Click</strong> for seamless digital payments</span>
            </li>
          </ul>
          <p className="mt-3 text-sm text-gray-500">Each offers unique integration opportunities for your projects.</p>
        </div>
      )
    },
    {
      question: "Do I need prior experience with FinTech or APIs?",
      answer: "While basic programming knowledge is helpful, our courseworks is designed to accommodate various skill levels. The Skills Development includes comprehensive learning materials to get you started, regardless of your current experience."
    },
    {
      question: "What environments are available for testing?",
      answer: (
        <div>
          <p className="mb-3">We provide three environments for your development journey:</p>
          <div className="grid gap-3">
            <div className="flex items-center p-3 bg-gray-50 rounded-lg">
              <div className="w-3 h-3 bg-green-500 rounded-full mr-3"></div>
              <div>
                <span className="font-semibold text-gray-800">Sandbox</span>
                <span className="text-gray-600 ml-2">- Initial learning and testing</span>
              </div>
            </div>
            <div className="flex items-center p-3 bg-gray-50 rounded-lg">
              <div className="w-3 h-3 bg-yellow-500 rounded-full mr-3"></div>
              <div>
                <span className="font-semibold text-gray-800">Staging</span>
                <span className="text-gray-600 ml-2">- Advanced development</span>
              </div>
            </div>
            <div className="flex items-center p-3 bg-gray-50 rounded-lg">
              <div className="w-3 h-3 bg-blue-600 rounded-full mr-3"></div>
              <div>
                <span className="font-semibold text-gray-800">Production</span>
                <span className="text-gray-600 ml-2">- Real-world implementation and certification</span>
              </div>
            </div>
          </div>
        </div>
      )
    },
    {
      question: "Loaded script is disabled when I npm install in vscode, how do i fix it?",
      answer: "Run this command 'Set-ExecutionPolicy -Scope CurrentUser -ExecutionPolicy RemoteSigned' in Windows PowerShell as Administrator."
    },
    {
      question: "Which environment should I start on first?",
      answer: "The first environment you should start on is Sandbox environment, followed by UAT environment, and lastly Production environment."
    },
    {
      question: "Where do I obtain the resources for Sandbox environment from?",
      answer: "Create an account on developer openapipass portal first. Once logged in, navigate to the menu bar found in the top left corner, expand on the resources tab, downloads, and navigate your way to PolyFinTech folder, and click on PayTech folder. "
    },
    {
      question: "Where do I obtain the password for Sandbox environment from?",
      answer: "The password would be provided in the briefing slides."
    },
    {
      question: "I am unable to proceed on to UAT and Production projects.",
      answer: "You would need to get certified in Sandbox environment first before creating a UAT project. After getting certified in UAT, then you can proceed on Production."
    },
    {
      question: "Where do I get the password for downloading PolyFinTech resources?",
      answer: "The password is PolyFinTech2025"
    },
    {
      question: "What are the maintenance downtime?",
      answer: "OPENAPIPAAS servers is down for maintenance between 12pm to 1pm everyday and every Wednesday between 9pm to 11pm."
    },
    {
      question: "What is the password for UAT and Go Live Resources under Skills Development?",
      answer: "The password will be provided after you have passed the certification for Sandbox environment."
    }
  ];

  return (
    <div className="min-h-screen bg-white flex flex-col font-sans text-gray-800">
      <Header />
      
      <main className="flex-grow">
        {/* Hero Section */}
        <section className="text-center pt-20 pb-2 text-gray-800">
          <div className="container mx-auto px-4 sm:px-6">
            <h1 className={`font-extrabold mb-5 text-gray-700 ${
              isMobile ? 'text-3xl' : 'text-5xl'
            }`}>
              PolyFinTech100 API Hackathon
            </h1>
            <p className="text-xl mb-10 text-gray-600 max-w-2xl mx-auto leading-relaxed">
              Welcome! Choose your learning journey and develop <br /> Financial Technology (FinTech) skills through PolyFinTech100 API Hackathon.
            </p>
          </div>
        </section>

        {/* Choose Your Path Section */}
        <section className="pt-4 pb-8">
          <div className="container mx-auto px-4 sm:px-6">
            {/* Routes Intro */}
            <div className="text-center mb-16 text-gray-800">
              <h2 className={`font-extrabold mb-5 text-gray-700 ${
                isMobile ? 'text-3xl' : 'text-5xl'
              }`}>
                Choose Your Path
              </h2>
            </div>

            {/* Routes Grid - 2 cards only */}
            <div className={`mt-10 ${isMobile ? 'grid grid-cols-1 gap-8' : 'grid grid-cols-2 gap-10'}`}>
              
              {/* Skills Development Card */}
              <div className="route-card bg-white bg-opacity-95 rounded-3xl p-10 shadow-xl transition-all duration-300 relative overflow-hidden flex flex-col h-full border-2 border-gray-100 hover:shadow-2xl hover:-translate-y-3 hover:border-gray-200">
                {/* Top Border */}
                <div className="absolute top-0 left-0 right-0 h-1.5 bg-gradient-to-r from-gray-800 to-gray-600 rounded-t-3xl"></div>
                
                {/* Header */}
                <div className="flex items-center justify-center mb-8">
                  <div className="w-15 h-15 rounded-2xl bg-gradient-to-br from-gray-800 to-gray-600 flex items-center justify-center mr-5 text-2xl font-bold text-white">
                    🎓
                  </div>
                  <div className="text-3xl font-bold text-gray-800">Skills Development</div>
                </div>
                
                {/* Description */}
                <p className="text-gray-600 text-lg leading-relaxed mb-8 flex-grow">
                  Get certified. Progress through structured coursework in Sandbox, Staging or Production environments.
                </p>
                
                {/* Button */}
                <a 
                  href="/skills-development" 
                  className="route-button bg-blue-600 text-white py-4 px-8 rounded-xl text-lg font-semibold cursor-pointer transition-all duration-300 w-full text-center inline-block no-underline hover:bg-blue-700"
                  onMouseEnter={(e) => handleButtonHover(e, true)}
                  onMouseLeave={(e) => handleButtonHover(e, false)}
                >
                  Get Started
                </a>
              </div>

              {/* Competition Route Card */}
              <div className="route-card bg-white bg-opacity-95 rounded-3xl p-10 shadow-xl transition-all duration-300 relative overflow-hidden flex flex-col h-full border-2 border-gray-100 hover:shadow-2xl hover:-translate-y-3 hover:border-gray-200">
                {/* Top Border */}
                <div className="absolute top-0 left-0 right-0 h-1.5 bg-gradient-to-r from-gray-600 to-gray-500 rounded-t-3xl"></div>
                
                {/* Header */}
                <div className="flex items-center justify-center mb-8">
                  <div className="w-15 h-15 rounded-2xl bg-gradient-to-br from-gray-600 to-gray-500 flex items-center justify-center mr-5 text-2xl font-bold text-white">
                    🏆
                  </div>
                  <div className="text-3xl font-bold text-gray-800">Competition</div>
                </div>
                
                {/* Description */}
                <p className="text-gray-600 text-lg leading-relaxed mb-8 flex-grow">
                  Compete to win. Choose between NETS QR, eNETS, and NETS Click payment gateways for your competition prototype.
                </p>
                
                {/* Button */}
                <a 
                  href="/competition" 
                  className="route-button bg-blue-600 text-white py-4 px-8 rounded-xl text-lg font-semibold cursor-pointer transition-all duration-300 w-full text-center inline-block no-underline hover:bg-blue-700"
                  onMouseEnter={(e) => handleButtonHover(e, true)}
                  onMouseLeave={(e) => handleButtonHover(e, false)}
                >
                  Get Started
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Workshop Section */}
        <section className="pt-8 pb-8">
          <div className="container mx-auto px-4 sm:px-6">
            {/* Workshop Intro */}
            <div className="text-center mb-16 text-gray-800">
              <h2 className={`font-extrabold mb-5 text-gray-700 ${
                isMobile ? 'text-3xl' : 'text-5xl'
              }`}>
                NETS Workshops
              </h2>
            </div>

            {/* Workshop Card - Centered */}
            <div className="flex justify-center">
              <div className="route-card bg-white bg-opacity-95 rounded-3xl p-10 shadow-xl transition-all duration-300 relative overflow-hidden flex flex-col h-full border-2 border-gray-100 hover:shadow-2xl hover:-translate-y-3 hover:border-gray-200">
                {/* Top Border - Same as Skills Development */}
                <div className="absolute top-0 left-0 right-0 h-1.5 bg-gradient-to-r from-gray-800 to-gray-600 rounded-t-3xl"></div>
                
                {/* Header - Same structure as route cards */}
                <div className="flex items-center justify-center mb-8">
                  <div className="w-15 h-15 rounded-2xl bg-gradient-to-br from-gray-800 to-gray-600 flex items-center justify-center mr-5 text-2xl font-bold text-white">
                    📅
                  </div>
                  <div className="text-3xl font-bold text-gray-800">Onsite & Online Sessions</div>
                </div>
                
                {/* Description - Same structure with flex-grow */}
                <p className="text-gray-600 text-lg leading-relaxed mb-8 flex-grow">
                  Indicate which workshop certification date/time you would like to attend.
                </p>
                
                {/* Button - Same structure as route cards */}
                <a 
                  href="https://docs.google.com/forms/d/e/1FAIpQLSeCjR6hUZ4u3eHPewXZ3QVrJv_r1YlEo3D3Dq36Fbm20lAmag/viewform?usp=dialog"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="route-button bg-blue-600 text-white py-4 px-8 rounded-xl text-lg font-semibold cursor-pointer transition-all duration-300 w-full text-center inline-block no-underline hover:bg-blue-700 flex items-center justify-center"
                  onMouseEnter={(e) => handleButtonHover(e, true)}
                  onMouseLeave={(e) => handleButtonHover(e, false)}
                >
                  <svg 
                    className="w-5 h-5 mr-2" 
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path 
                      strokeLinecap="round" 
                      strokeLinejoin="round" 
                      strokeWidth={2} 
                      d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" 
                    />
                  </svg>
                  Book Appointment
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Professional FAQ Section */}
        <section className="pt-16 pb-20 bg-gradient-to-br from-gray-50 to-white">
          <div className="container mx-auto px-4 sm:px-6">
            {/* FAQ Header */}
            <div className="text-center mb-16">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-600 rounded-2xl mb-6">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h2 className={`font-bold mb-4 text-gray-800 ${
                isMobile ? 'text-3xl' : 'text-4xl'
              }`}>
                Frequently Asked Questions
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
                Everything you need to know about PolyFinTech100. Can't find the answer you're looking for? 
                <span className="text-blue-600 font-medium"> Feel free to reach out to our team.</span>
              </p>
            </div>

            {/* FAQ Accordion */}
            <div className="max-w-4xl mx-auto">
              <div className="space-y-3">
                {faqData.map((faq, index) => (
                  <div 
                    key={index} 
                    className={`bg-white rounded-xl border transition-all duration-300 overflow-hidden ${
                      expandedFAQ[index] 
                        ? 'border-blue-200 shadow-lg shadow-blue-50' 
                        : 'border-gray-200 shadow-sm hover:border-gray-300 hover:shadow-md'
                    }`}
                  >
                    {/* Question Button */}
                    <button
                    onClick={() => toggleFAQ(index)}
                    className="w-full px-6 py-6 text-left flex items-center justify-between group transition-all duration-200 hover:bg-gray-50/50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded-xl"
                  >
                    <h3 className="text-lg font-semibold text-gray-800 pr-8 group-hover:text-blue-600 transition-colors duration-200">
                      {faq.question}
                    </h3>
                    
                    {/* Modern Toggle Icon */}
                    <div className={`flex-shrink-0 w-8 h-8 rounded-full border-2 flex items-center justify-center transition-all duration-300 ${
                      expandedFAQ[index] 
                        ? 'border-blue-600 bg-blue-600 rotate-180' 
                        : 'border-gray-300 group-hover:border-blue-600'
                    }`}>
                      {expandedFAQ[index] ? (
                        <Minus size={16} className="text-white" />
                      ) : (
                        <Add size={16} className={`transition-colors duration-200 ${
                          expandedFAQ[index] ? 'text-white' : 'text-gray-600 group-hover:text-blue-600'
                        }`} />
                      )}
                    </div>
                  </button>
                    
                    {/* Answer Content */}
                    <div 
                      className={`transition-all duration-500 ease-in-out ${
                        expandedFAQ[index] 
                          ? 'max-h-[500px] opacity-100' 
                          : 'max-h-0 opacity-0'
                      }`}
                    >
                      <div className="px-6 pb-6 pt-0">
                        <div className="w-full h-px bg-gradient-to-r from-blue-600/20 to-transparent mb-4"></div>
                        <div className="text-gray-600 leading-relaxed space-y-2">
                          {faq.answer}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>


          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default PolyFinTechLayout;